import React from 'react';
import {useQueryParam} from "../routerHooks";
import {useBodyColor} from "../hooks";
import MobilePage from "../components/MobilePage";
import {Card, FormGroup, NonIdealState} from "@blueprintjs/core";
import Select from "react-select";
import {StandingsView} from "./new-standings/index";
// import {StandingsView as StandingsViewOld} from "./StandingsView";
import styled from 'styled-components';
import gql from 'graphql-tag';
import {useQuery} from "@apollo/client";

const TEAM_GROUPS_QUERY = gql`
    query ($seasonId: Int!) {
        teamGroupsBySeason(id: $seasonId) {
            id
            name
            rank
        }
    }
`

const SEASON_FROM_TEAM_GROUPS_QUERY = gql`
    query ($teamGroupId: Int!) {
        divisionsByTeamGroup(id: $teamGroupId) {
            season {
                id
                name
            }
        }
    }
`


const StyledCard = styled(Card)`
  margin: 10px 0;
`

const StandingsPage = ({ allDivisions: divisions, division, setDivision, seasonName }) => {
  useBodyColor('#ECF7FE')

  const [selectedDivision, setSelectedDivision] = React.useState(null);


  return (
    <MobilePage
      wrapContentInCards={false}
      titleContent={
        <>
          <h1 style={{textAlign: 'center', margin: 0, padding: 0}}>{seasonName} Standings</h1>
        </>
      }
    >
      <StyledCard
        style={{zIndex: 50, position: 'relative'}}
      >
        <FormGroup
          label={'Choose Division'}
        >
          <Select
            placeholder={divisions.length > 0 ? 'Select...' : 'Loading...'}
            options={divisions}
            value={division ? divisions.filter(div => div.value === division)[0] : selectedDivision}
            onChange={e => {
              setDivision(e.value)
              setSelectedDivision(e)
            }}
            blurInputOnSelect={true}
          />
        </FormGroup>
      </StyledCard>

      <>
        {!(division ? divisions.filter(div => div.value === division)[0] : selectedDivision) &&
          <NoDivisionSelected />
        }

        {(division ? divisions.filter(div => div.value === division)[0] : selectedDivision) &&
          <StandingsView division={(division ? divisions.filter(div => div.value === division)[0] : selectedDivision)} />
        }
      </>
    </MobilePage>
  )
}

const NoDivisionSelected = () => {
  return (
    <StyledCard>
      <NonIdealState
        icon={'timeline-bar-chart'}
        title={'Standings'}
        description={'Choose A Division To View The Standings'}
      />
    </StyledCard>
  )
}


function Wrapper(props) {

  const { data } = useQuery(TEAM_GROUPS_QUERY, {
    variables: {
      seasonId: props.seasonId
    }
  })

  if (!data) return ''

  const divisions = data.teamGroupsBySeason.map(group => {
    return {
      value: group.id,
      label: group.name
    }
  })

  return <StandingsPage allDivisions={divisions} division={props.teamGroup ? parseInt(props.teamGroup) : null} setDivision={props.setTeamGroup} seasonName={props.seasonName} />
}

export default () => {
  const [teamGroup, setTeamGroup] = useQueryParam('g')

  const { data } = useQuery(SEASON_FROM_TEAM_GROUPS_QUERY, {
    variables: {
      teamGroupId: parseInt(teamGroup ?? 1018)
    }
  })

  if (!data) return ''

  return <Wrapper seasonId={data.divisionsByTeamGroup[0].season.id} setTeamGroup={setTeamGroup} teamGroup={teamGroup} seasonName={data.divisionsByTeamGroup[0].season.name} />
}
